import { clearClaimAttachment } from 'feature/claims/claimSlice';
import { clearComplaintAttachment } from 'feature/complaintTracking/complaintTrackingSlice';
import { clearFraudAttachment } from 'feature/fraudTracking/fraudTrackingSlice';
import { thunkLoadingParams } from 'feature/progressIndicator/progressIndicatorSlice';
import { STATE_KEYS, ThunkApiType } from 'types/Store';
import { DocType } from 'types/Upload';
import { camelcaseToUnderscore } from 'utils/utils';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';
import { setUploadPercentage } from './uploadSlice';

export const uploadDocumentThunk = async (
	arg: thunkLoadingParams & { docType: DocType },
	thunkAPI: ThunkApiType,
) => {
	const {
		claimData: { memberSubscriptionUuid },
	} = thunkAPI.getState().claim;

	const { file } = thunkAPI.getState().upload;

	const sendFileURL = `/attachments/${camelcaseToUnderscore(
		arg.docType,
	)}?subscriptionUuid=${memberSubscriptionUuid}`;

	let formData = new FormData();
	formData.append('image', file);

	try {
		const response = await authFetch.post(sendFileURL, formData, {
			signal: thunkAPI.signal,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Content-Length': file.size,
			},
			onUploadProgress: upload => {
				let progress = Math.round((100 * upload.loaded) / (upload?.total || 0));
				thunkAPI.dispatch(setUploadPercentage(progress));
			},
		});
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const deleteDocumentThunk = async (
	{
		uuid,
		docType,
		clearState,
	}: { uuid: string; docType: DocType; clearState: STATE_KEYS | undefined },
	thunkAPI: ThunkApiType,
) => {
	switch (clearState) {
		case STATE_KEYS.CLAIM:
			thunkAPI.dispatch(clearClaimAttachment({ uuid, docType }));
			return true;
		case STATE_KEYS.COMPLAINT:
			thunkAPI.dispatch(clearComplaintAttachment({ uuid, docType }));
			return true;
		case STATE_KEYS.FRAUD:
			thunkAPI.dispatch(clearFraudAttachment({ uuid, docType }));
			return true;
		default:
			break;
	}

	const deleteFileURL = `/attachments/${camelcaseToUnderscore(docType)}/${uuid}`;

	try {
		const response = await authFetch.delete(deleteFileURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const editDocumentNameThunk = async (
	{
		docType,
		fileName,
		documentUuid,
	}: { fileName: string; documentUuid: string; docType: DocType },
	thunkAPI: ThunkApiType,
) => {
	const sendFileURL = `/attachments/${camelcaseToUnderscore(
		docType,
	)}/${documentUuid}`;

	try {
		const response = await authFetch.put(sendFileURL, {
			fileName,
		});
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
